import React from 'react';
import Modal from 'react-modal';
import './styles.scss';

const ResetForwardCNAsModal = ({ shiftName, closeModal, handleConfirm }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    closeModal();
  };

  return (
    <Modal
      className="modal-alert reset-forward-cnas-modal"
      isOpen
      onRequestClose={handleClose}
      contentLabel="Reset forward CNAs modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <img src="/images/alert-icon.svg" alt="" />
        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Reset all {shiftName} CNAs</h3>
        <p>
          The assigned CNAs will be cleared from this shift and from every future {shiftName} of this unit.
        </p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Reset
        </button>
      </div>
    </Modal>
  );
};

export default ResetForwardCNAsModal;
